const basePath = '/admin';

const ADMIN_HOME = `${basePath}/home`;
const ADMIN_LOGIN_OTP = `${basePath}/login`;
const ADMIN_LOGIN = `${basePath}`;
const PRIVACY_POLICY = `${basePath}/privacy-policy`;
const TERMS_AND_CONDITIONS = `${basePath}/terms-and-conditions`;
const LOGOUT = `${basePath}/logout`;
const SCHOOL = `${basePath}/schools`;
const EXAMS = `${basePath}/exams`;
const SCHOOL_CONFIG = `${basePath}/school-config`;
const SCHOOL_STRUCTURE = `${basePath}/school-structure`;
const PAYMENT_CONFIG = `${basePath}/payment-config`;
const SCORING_TYPE = `${basePath}/scoring-type`;
const GRADE_SCALE = `${basePath}/grade-scales`;
const PENDING_FEE_REPORT = `${basePath}/pending-fee-report`;
const OUTSTANDING_FEE_REPORT = `${basePath}/outstanding-fee-report`;
const CASH_FLOW_STATEMENT = `${basePath}/cash-flow-statement`;
const PENDING_FEE_SUMMARY = `${basePath}/pending-fee-summary`;
const DAILY_BOOK = `${basePath}/daily-book`;
const TERMS = `${basePath}/terms`;
const SUBJECTS = `${basePath}/subjects`;
const ASSESSMENT_OVERVIEW = `${basePath}/assessment-overview`;
const ACADEMIC_YEARS = `${basePath}/academic-years`;
const ACADEMIC_YEAR_TERMS = `${basePath}/academic-year-terms`;
const LATE_FEE_CONFIG = `${basePath}/late-fee-config`;
const IMPORT_ROLLOVER_USERS = `${basePath}/import-rollover-users`;
const IMPORT_USERS = `${basePath}/import-users`;
const ADMIN_USERS = `${basePath}/admin-users`;
const ELECTIVES_ASSIGNMENT = `${basePath}/electives-assignment`;
const HASHTAGS = `${basePath}/hashtags`;
const MARKS_ANALYTICS = `${basePath}/marks-analytics`;
const ROLL_NO_UPDATE = `${basePath}/roll-no-update`;
const CONSOLIDATED_MARKS_REPORT = `${basePath}/consolidated-marks-report`;
const CHEQUE_STATUS_UPDATE = `${basePath}/cheque-status-update`;
const SEARCH_STUDENT_FEE_ENTRY = `${basePath}/search-student-fee-entry`;
const TRANSACTION_STATUS_UPDATE = `${basePath}/transaction-status-update`;

const routes = {
  ADMIN_HOME,
  PRIVACY_POLICY,
  TERMS_AND_CONDITIONS,
  ADMIN_LOGIN,
  ADMIN_LOGIN_OTP,
  LOGOUT,
  SCHOOL,
  SCHOOL_CONFIG,
  SCHOOL_STRUCTURE,
  PAYMENT_CONFIG,
  PENDING_FEE_REPORT,
  LATE_FEE_CONFIG,
  EXAMS,
  SCORING_TYPE,
  GRADE_SCALE,
  OUTSTANDING_FEE_REPORT,
  CASH_FLOW_STATEMENT,
  TERMS,
  SUBJECTS,
  ACADEMIC_YEAR_TERMS,
  ASSESSMENT_OVERVIEW,
  ACADEMIC_YEARS,
  IMPORT_ROLLOVER_USERS,
  PENDING_FEE_SUMMARY,
  DAILY_BOOK,
  IMPORT_USERS,
  ADMIN_USERS,
  ELECTIVES_ASSIGNMENT,
  HASHTAGS,
  MARKS_ANALYTICS,
  ROLL_NO_UPDATE,
  CONSOLIDATED_MARKS_REPORT,
  CHEQUE_STATUS_UPDATE,
  SEARCH_STUDENT_FEE_ENTRY,
  TRANSACTION_STATUS_UPDATE
};

export const publicRoutes = [
  ADMIN_LOGIN,
  ADMIN_LOGIN_OTP,
  PRIVACY_POLICY,
  TERMS_AND_CONDITIONS
];

export default routes;
